<template>
  <transition name="modal">
    <div id="easel-file-picker" class="media-manager">
      <div class="modal-header" v-if="isModal" >
        <!-- Close button for modal windows -->
        <button type="button" class="close" @click="close()">×</button>


      </div>

		<label v-if="currentPath != '/backgrounds'"
		class="btn btn-primary btn-icon-text btn-file mb-0 ml-3 float-right" 
		title="Select files to be uploaded - or drag files into the main window pane">
		<i class="fa fa-upload"/>
		<span class="">Upload File</span>
		<input

		  ref="mediaManagerUploadInput"
		  class="hidden d-none form-control-file"
		  name="files[]"
		  type="file"
		  @change="uploadFile({'name':$event.target.name, 'files':$event.target.files})" 
		>
		</label>

		<ul class="nav nav-tabs">
			<li class="nav-item">
				<a data-toggle="tab" :class="{'nav-link':true,'active':(currentPath.startsWith('/user'))}" href="#nav-uploaded" @click="loadFolder( '/user' )" >My Files</a>
			</li>
			<li class="nav-item">
				<a data-toggle="tab" :class="{' nav-link':true,'active':(currentPath == '/')}" href="#nav-uploaded" @click="loadFolder( '/' )">Company Files</a>
			</li>
			<!--<li class="nav-item">
				<a data-toggle="tab" :class="{'nav-link':true,'active':(currentPath == '/backgrounds')}" href="#nav-stock" @click="loadFolder( '/backgrounds' )">Backgrounds</a>
			</li>-->
			<li class="nav-item">
				<a data-toggle="tab" ref="solidcolorsTab" id="solidcolorsTab" :class="{'nav-link':true}" href="#solidcolors" @click="unsetCurrentPath">Solid Colour</a>
			</li>
		</ul>

		<div class="tab-content" id="nav-tabContent">

			<div :class="{'tab-pane':true,'active':(currentPath != '/backgrounds')}" id="nav-uploaded">

		      	<div 
		        id="mediaManagerDropZone" 
		        class="dropzone mt-3">
		        <div 
		          v-if="loading" 
		          class="easel-alternative-content loading p-0">
		          <p>
		            <span class="spinner fa fa-spinner"/>Loading...
		          </p>

		          <h4 v-if="uploadProgress > 0">{{ uploadProgress }} %</h4>
		        </div>

		        <div v-else>

		          <div class="easel-file-browser">

		            <div 
		              v-if="isFolderEmpty" 
		              class="easel-alternative-content">
		              <h4>This folder is empty.</h4>
		              <p v-if="currentPath != '/backgrounds'">
		                Drag and drop files onto this window to upload files.
		              </p>
		            </div>

		            <div 
		              v-else 
		              class="row">
		              <div 
		                
		                class="col">

		                <div class="easel-file-picker-list">

		                	<div class="row">
		                		<div class="col-3 mb-3 media-item" 
		                        v-for="file in orderedFiles"
		                        :key="file.name">
		                			
		                			<div class="controls-on-hover" >

		                				<img
									      v-if="isImage(file)"
									      id="easel-preview-image"
									      :src="file.webPath"
									      class="img-fluid center-block w-100"
									      @click="selectFile(file,true);"
		                            	  @keyup.enter="selectFile(file,true);"
		                            	  @dblclick="selectFile(file,true);"
									    >
									    <div v-else class="non-img-file text-center">
									    	
									    	<i v-if="file.mimeType == 'application/pdf'" class="icon fa fa-file-pdf-o"></i>
									    	
									    	<i v-else-if="file.mimeType == 'application/vnd.ms-excel'" class="icon fa fa-file-excel-o"></i>
											<i v-else-if="file.mimeType == 'application/vnd.ms-excel.addin.macroenabled.12'" class="icon fa fa-file-excel-o"></i>
											<i v-else-if="file.mimeType == 'application/vnd.ms-excel.sheet.binary.macroenabled.12'" class="icon fa fa-file-excel-o"></i>
											<i v-else-if="file.mimeType == 'application/vnd.ms-excel.sheet.macroenabled.12'" class="icon fa fa-file-excel-o"></i>
											<i v-else-if="file.mimeType == 'application/vnd.ms-excel.template.macroenabled.12'" class="icon fa fa-file-excel-o"></i>

									    	<i v-else class="icon fa fa-file-o"></i>

									    	<p>{{ file.name }}</p></div>
										<div class="controls">
											<a href="#" class="btn btn-sm btn-secondary" @click="selectFile(file);showDeleteItemModal=true"><i class="fa fa-trash"></i></a>
										</div>
									</div>
		                		</div>
		                	</div>






		                </div>
		              </div>
		              
		            </div>
		          </div>
        	</div>

        </div>

        <div v-if="isModal"  class="modal-footer vertical-center">
          
          <!-- Buttons to be rendered if the media-manager is in a modal window-->
          <div 
            
            class="buttons">
            <button
              v-show="currentFile && !isFolder(currentFile)"
              type="button"
              class="btn btn-primary"
              @click="selectFile(false,true);">
              Select File
            </button>
            <button 
              type="button" 
              class="btn btn-default" 
              @click="close()">
              Close
            </button>
          </div>
        </div>
      </div>

      <div :class="{'tab-pane':true,'active':(currentPath == '/backgrounds')}" id="nav-stock">
					
				<div v-if="loading" class="easel-alternative-content loading p-0">
		          <p>
		            <span class="spinner fa fa-spinner"/>Loading...
		          </p>
		        </div>
		        <div v-else>

		          <div class="easel-file-browser">



		            <div class="row">
		              <div class="col">

		                <div class="easel-file-picker-list">

		                	<div class="row">
		                		<div class="col-3 mb-3 media-item" 
		                        v-for="file in orderedFiles"
		                        :key="file.name">
		                			
		                			<div class="controls-on-hover" >

		                				<img
									      v-if="isImage(file)"
									      id="easel-preview-image"
									      :src="file.webPath"
									      class="img-fluid center-block w-100"
									      @click="selectFile(file,true);"
		                            	  @keyup.enter="selectFile(file,true);"
		                            	  @dblclick="selectFile(file,true);"
									    >
									    <div v-else class="non-img-file text-center">
									    	
									    	<i v-if="file.mimeType == 'application/pdf'" class="icon fa fa-file-pdf-o"></i>
									    	
									    	<i v-else-if="file.mimeType == 'application/vnd.ms-excel'" class="icon fa fa-file-excel-o"></i>
											<i v-else-if="file.mimeType == 'application/vnd.ms-excel.addin.macroenabled.12'" class="icon fa fa-file-excel-o"></i>
											<i v-else-if="file.mimeType == 'application/vnd.ms-excel.sheet.binary.macroenabled.12'" class="icon fa fa-file-excel-o"></i>
											<i v-else-if="file.mimeType == 'application/vnd.ms-excel.sheet.macroenabled.12'" class="icon fa fa-file-excel-o"></i>
											<i v-else-if="file.mimeType == 'application/vnd.ms-excel.template.macroenabled.12'" class="icon fa fa-file-excel-o"></i>

									    	<i v-else class="icon fa fa-file-o"></i>

									    	<p>{{ file.name }}</p></div>
									</div>
		                		</div>
		                	</div>






		                </div>
		              </div>
		              
		            </div>
		          </div>
        	</div>
			</div>
			
			<div class="tab-pane" id="solidcolors" role="tabpanel" >
				<background-color-picker :color="defaultColor" @newcolor="selectBackgroundColor" @cancel="cancel"></background-color-picker>
			</div>

  	  </div>
      <sd-modal-create-folder
        :current-path="currentPath"
        :prefix="prefix"
        :show="showCreateFolderModal"
        @media-modal-close="showCreateFolderModal = false"
        @reload-folder="loadFolder( currentPath )"
      />

      <sd-modal-delete-item
        :current-path="currentPath"
        :current-file="currentFile"
        :prefix="prefix"
        :show="showDeleteItemModal"
        @media-modal-close="showDeleteItemModal = false"
        @reload-folder="loadFolder( currentPath )"
      />

      <sd-modal-move-item
        :current-path="currentPath"
        :current-file="currentFile"
        :prefix="prefix"
        :show="showMoveItemModal"
        @media-modal-close="showMoveItemModal = false"
        @reload-folder="loadFolder( currentPath )"

      />

      <sd-modal-rename-item
        :current-path="currentPath"
        :current-file="currentFile"
        :prefix="prefix"
        :show="showRenameItemModal"
        @media-modal-close="showRenameItemModal = false"
        @reload-folder="loadFolder( currentPath )"

      />

    </div>
  </transition>
</template>

<script>
import axios from "axios";
import {orderBy} from "lodash";
import fileManagerMixin from "./mixins/file-manager-mixin.js";

import Noty from 'noty';

export default{
	components:{
	},

	mixins: [fileManagerMixin],

	props: {
		/**
         * Is this instance of the media manager a modal window.
         * If so then this property is used to show the close
         * buttons at the top and bottom of the screen.
         */
		isModal: {
			default: false,
			type: Boolean
		},

		/**
             * Default route prefix
             */
		prefix: {
			default : "/sd-media/",
			type: String
		},

		/**
             * The event to be fired when selectItem() is called.
             * The actual event name emitted is prefixed w/
             * "media-manager-selected-" so to avoid
             * clashes w/ other events.
             */
		selectedEventName: {
			default: "",
			type: String
		},

		/**
             * If this instance is a modal window then this
             * property is used to show or hide the
             * modal window.
             */
		show: {
			default: false,
			type: Boolean
		},

		reference:{
			default: "",
			type: String
		},

		defaultTab:{
			default: "user",
			type: String
		},

		defaultColor:{
			default: "#e4e1dd",
			type: String
		}
	},

	data: function () {

		return {

			/**
             * breadCrumbs for the current path that are used to go
             * backwards through the directory tree.
             */
			breadCrumbs: {},

			/**
             * The currently highlighted file
             */
			currentFile: {},

			/**
             * The current path that the media manager is displaying
             */
			currentPath: "/user",

			/**
             * All of the files in the current path
             */
			files: [],

			/**
             * The current path's folder name
             */
			folderName: null,

			/**
             * All of the sub folders in the current path
             */
			folders: [],

			/**
             * Property to show the loading indicator
             */
			loading: true,

			/**
             * Property to show upload progress
             */
			uploadProgress: 0,

			/**
             * Total files and folder count
             */
			itemsCount: 0,

			/**
             * properties to show and hide internal modal windows
             */
			showCreateFolderModal: false,
			showDeleteItemModal: false,
			showMoveItemModal: false,
			showRenameItemModal: false,

			/**
             * property to hold direction of column sorting
             */
			sortDirection: false,


			/**
             * property to hold element reference
             */
			elementRef : this.reference,
		};
	},

	computed:{
		isFolderEmpty(){
			return ((this.files.length + this.folders.length ) === 0);
		},
		orderedFiles: function () {
			return _.orderBy(this.files, 'modified', 'desc')
		}

	},

	mounted: function () {

		if(this.defaultTab == '#solidcolors'){
			this.unsetCurrentPath(); this.$refs.solidcolorsTab.click();
		}else{
			this.currentPath = '/'+this.defaultTab;
			this.loadFolder();
			this.dragUpload();
		}

		


		if( ! this.prefix.endsWith("/") )
		{
			this.prefix = `${this.prefix}/`;
		}

		

	},

	methods: {
		unsetCurrentPath(){
			this.currentPath = "";
		},
		/**
         * sort files and folders...
         * @param column
         */
		orderBy(column)
		{
			this.sortDirection = !this.sortDirection;
			const order = (this.sortDirection)? "desc" : "asc";
			this.files = orderBy(this.files, [column], [order]);
			this.folders = orderBy(this.folders, [column], [order]);
		},

		close() {
			this.breadCrumbs = {};
			this.currentFile = {};
			this.currentPath = "";
			this.files = {};
			this.folderName = "";
			this.folders = {};
			this.itemsCount = 0;
			this.$emit("media-modal-close");
		},
		loadFolder(path){


			this.uploadProgress = 0;
			if (!path) {
				path = ( this.currentPath ) ? this.currentPath : "";
			}


				this.loading = true;
				this.currentFile = false;

				if(path == '/backgrounds'){
					var url = `${this.prefix}browser/backgrounds`;
				}else{
					var url = `${this.prefix}browser/index?path=${path}`;
				}

				axios.get(url).then(
					(response) => {
						this.breadCrumbs = response.data.breadCrumbs;
						this.currentFile = {};
						this.currentPath = response.data.folder;
						this.loading = false;
						this.files = response.data.files;
						this.folderName = response.data.folderName;
						this.folders = response.data.subFolders;
						this.itemsCount = response.data.itemsCount;
					},
					(response) => {
						if (response.data.error) {
							this.mediaManagerNotify(response.data.error, "danger");
						}

						this.loading = false;
						this.currentFile = {};
					}

			);

			
		},

		previewFile(file){
			this.currentFile = file;
		},

		uploadFile(payload){


			let fieldName = payload.name;
			let fileList = payload.files;





			/**
             * Create a new form request object.
             * Gather all of the files to be uploaded and append them to it.
             * Attach the current path so the server knows where to upload the files to.
             * Send a post request to the server...
             */
			const form = new FormData();
			Array
				.from(Array(fileList.length).keys())
				.map(x => {
					form.append(fieldName, fileList[x], fileList[x].name);
				});
                
			form.append("folder", this.currentPath);

			this.loading = true;
			axios.post(`${this.prefix}browser/file`, form, {
				progress(e){
					if (e.lengthComputable) {
						this.uploadProgress = parseFloat( Math.round(e.loaded / e.total * 100) ).toFixed(2);
					}
				}
			}
			).then(
				(response) => {
					this.mediaManagerNotify(response.data.success);
					this.loadFolder(this.currentPath);
					this.$refs.mediaManagerUploadInput.value = '';
				},
				(response) => {
					const error = (response.data.error) ? response.data.error : response.statusText;
					// when uploading we might have some files uploaded and others fail
					if (response.data.notices) this.mediaManagerNotify(response.data.notices);
					this.mediaManagerNotify(error, "danger", 5000);
					this.loadFolder(this.currentPath);
					this.$refs.mediaManagerUploadInput.value = '';
				}
			).catch( error => {
             
                      new Noty({
                                text: 'There has been an error uploading. This file may be too large (over 5 MB) or not a supported image type. Please check and try again.',
                                type: 'error',
                                theme: 'bootstrap-v4',
                                layout: 'topCenter',
                                timeout: 2000
                            }).show();

                      this.loadFolder(this.currentPath);

                      this.$refs.mediaManagerUploadInput.value = '';
                    
              });

		},
		cancel(){
			this.$emit("cancel");
		},
		selectBackgroundColor(colorhex){

			// we create a canvas element
			var canvas = document.createElement('canvas');
			var height=60;
			var width=60;

			canvas.height=height;
			canvas.width=width;
			// getting the context will allow to manipulate the image
			var context = canvas.getContext("2d");
			
			// Fill with coloured rectangle
			context.fillStyle = colorhex;
			context.fillRect(0, 0, canvas.width, canvas.height);

			var dataURL = canvas.toDataURL("image/png");

			this.$emit("selectedImageFromLibrary",{reference:this.elementRef, src:dataURL});

			//var esccolorhex = colorhex.replace('#', '%23');
			//this.$emit("selectedImageFromLibrary",{reference:this.elementRef, src:"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1 1'><path d='M0 0h1v1H0z' fill='" + esccolorhex + "'/></svg>"});
		},
		selectFile(file,chooseFile=false){

			

			/**
             * If file is passed, then set as current file
             */
			if(file){this.currentFile = file;}


			/**
             * If file is image, then emit url
             */
            if(chooseFile){
	            if(this.isImage(this.currentFile)){	
	                var newImageSrc = {reference:this.elementRef, src:this.currentFile.webPath};
	                this.$emit("selectedImageFromLibrary",newImageSrc);
	            }
        	}
			/**
             * Only dispatch an event if a custom event has been defined
             */

			if (this.selectedEventName) {
				this.$emit("media-manager-selected-" + this.selectedEventName, this.currentFile);
			}
		},

		dragUpload(){
            let Dropzone = require('dropzone'); //eslint-disable-line
			Dropzone.autoDiscover = false;
			this.dropzone = new Dropzone("div#mediaManagerDropZone", {
				clickable: false,
				createImageThumbnails: false,
				dictDefaultMessage: "",
				enqueueForUpload: true,
				paramName: "files",
				previewsContainer: null,
				previewTemplate: "<span class=\"hidden\"></span>",
				hiddenInputContainer: true,
				uploadMultiple: true,
				url: `${this.prefix}browser/file`,
				headers: {
					"X-CSRF-TOKEN": window.axios.defaults.headers.common["X-CSRF-TOKEN"]
				},

				sending: (file, xhr, form) => {
					this.loading = true;
					form.append("folder", this.currentPath);
				},

				completemultiple: () => {
					this.loading = false;
					this.loadFolder(this.currentPath);
				},

				errormultiple: (files, response) => {
					this.mediaManagerNotify(response.error);
				},

				successmultiple: (files, response) => {
					this.mediaManagerNotify(response.success);
				},

				totaluploadprogress: (uploadProgress) => {
					this.uploadProgress = parseFloat(Math.round(uploadProgress * 100) / 100).toFixed(2);
					if (this.uploadProgress < 100) {
						this.loading = true;
					} else {
						this.uploadProgress = 0;
						this.loading = false;
					}
				}

			});
		}
	}
};
</script>
<style type="text/css">
	.dropzone{
		padding: 0;
		margin: 0;
	}
	.media-item{
		overflow: hidden;
		height: 244px;
	}
	#easel-file-picker.media-manager .easel-file-browser .easel-file-picker-list{
		height: auto;
		overflow-y: visible; 
	}
	#easel-file-picker .easel-file-browser{
		height: 60vh;
	}
</style>
